<template>
	<v-container fluid class="pt-0" fill-height>
		
	 
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-0">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text class="pb-0">
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Kardex
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-show="verCalificaciones" class="py-0">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-title class="py-0">
          	<v-spacer></v-spacer>
            <vue-apex-charts
              type="radialBar" height="250" width="250" :options="chartOptions" :series="series"
            ></vue-apex-charts>
          	<v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-col>
		<!--Angel Rodriguez-->
		<v-row justify="center">
		<v-col cols="12" sm="8" md="6" lg="4" v-show="comentarios.length">
	  		<v-card class="cardBasic">

	  		  <v-card-text>
	  		  	<v-data-table
					    :headers="headersComentarios"
					    :items="comentarios"
						:items-per-page="comentarios.length"
					    class="elevation-0"
					    :mobile-breakpoint="100"
					    hide-default-footer
					  >	
			  </v-data-table>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	</v-row >

	<v-row justify="center">
	  	<v-col cols="12" sm="8" md="6" lg="4" v-show="verCalificaciones">
	  		<v-card class="cardBasic">
	  		  <v-card-title primary-title class="py-1">
	  		    <div class="card-header pb-0">
				      <h6>{{ getUsuarioLMS.nombre_completo }}</h6>
				    </div>
			      <v-spacer></v-spacer>
			      <v-btn icon><v-icon>mdi-printer</v-icon></v-btn>
	  		  </v-card-title>

	  		  <v-card-text>
	  		  	<v-data-table
					    :headers="headers"
					    :items="calificaciones"
					    :items-per-page="calificaciones.length"
					    class="elevation-0"
					    :mobile-breakpoint="100"
					    hide-default-footer
					  >
					  	<template v-slot:item.nivel="{ item }">
					      <v-avatar
			            size="28"
			            color="transparent"
			            rounded
			            class="elevation-1 avatares shadowCard"
			          >
			            <span class="white--text"><strong> {{ item.nivel }} </strong></span>
			          </v-avatar>
		    			</template>

		    			<template v-slot:item.primera="{ item }">
					      <p class="text-body-1 my-2 font-weight-bold text-center grey--text"> {{ item.primera }} </p>
		    			</template>

		    			<template v-slot:item.segunda="{ item }">
					      <p class="text-body-1 my-2 font-weight-bold text-center grey--text"> {{ item.segunda }} </p>
		    			</template>

					  </v-data-table>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>		
	  </v-row>

	  <v-speed-dial
      top
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          dark
          fab
          :to="{name: 'Perfil'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'
	import VueApexCharts from 'vue-apexcharts'
	const  base64 = require('base-64');

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
		components: {
	    Alerta,
	    VueApexCharts,
	    Loader
	  },

	  name: "dashboard-default",

	  data: () => ({

	  	headers: [
        { text: 'NIVEL',          value: 'nivel'  , class: 'text-uppercase grey--text text-caption' },
        { text: 'ORDINARIO',      value: 'primera', class: 'text-uppercase grey--text text-caption text-left' },
        { text: 'EXTRAORDINARIO', value: 'segunda', class: 'text-uppercase grey--text text-caption text-left' },

      ],

	  headersComentarios: [
        { text: 'Nivel',          value: 'nivel'  , class: 'text-uppercase grey--text text-caption' },
        { text: 'Maestro',      value: 'maestro', class: 'text-uppercase grey--text text-caption text-left' },
		{ text: 'Calificación', value: 'calificacion', class: 'text-uppercase grey--text text-caption text-left' },
        { text: 'Comentario', value: 'mensaje', class: 'text-uppercase grey--text text-caption text-left' },

      ],

	  	verCalificaciones: false,
		showPanel: false,

	  	calificaciones: [],
		comentarios: [],

	  	show: false,

    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

      series: [0],
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
             hollow: {
              margin: 0,
              size: '70%',
              background: '#fff',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              }
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },
        
            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px'
              },
              value: {
                formatter: function(val) {
                  return parseFloat(val);
                },
                color: '#111',
                fontSize: '36px',
                show: true,
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        labels: ['Promedio'],
      },
	  }),

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario' ])
	  },

	  created () {
	  	this.cargar = true
	  	const id_usuario = base64.encode( this.getUsuarioLMS.id )
	  	// Limpiamos el arreglo
	  	this.calificaciones = []
		this.comentarios = []
	  	// Hacemos la petición
	  	this.$http.get('usuario.kardex/' + id_usuario).then( response => {
	  		// Guardamos las calificaciones
	  		this.calificaciones = response.body.getKardexalumno
			this.comentarios    = response.body.getComentario
	  		const promedio      = response.body.promedio
		  	
		  	this.series       = [parseFloat(promedio).toFixed(2)]
		  	console.log(this.series)

				this.verCalificaciones = true
				this.cargar = false
	  	}).catch( error =>{
	  		this.cargar                    = false
    		if( error.status == 400 || error.status == 500 ){
    			this.parametros.mensaje      = error.body.message
    			this.parametros.dialogError  = true 
    			this.parametros.color        = '#FF2C2C' 
    			this.respuestaAlerta         = true 
    		}
  		}).finally( () => { this.cargar = false })

		const estado = this.getCalificaciones.estatus  //ANGEL RODRIGUEZ
	

		//ANGEL RODRIGUEZ
		this.showPanel = estado === 1;

	  	
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getCalificaciones', 'getUsuarioLMS', 'getRecursosGrupoUsuario' ])
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno'] ),

	  }
	};
</script>

<style scoped>
	.avatares{
		background: rgb(240,240,240);
		background: linear-gradient(90deg, rgba(240,240,240,1) 0%, rgba(219,219,219,1) 100%);
	}

	.shadowCard{
		border-radius: 8px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.cardBasic{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.colorCurso{
		color: #006093;
	}

	</style>
